import React from 'react';
import PropTypes from 'prop-types';
import { StyledDayNumber } from './style';

const DayNumber = ({ date, className }) => (
  <StyledDayNumber className={className} format="DD" element="span">
    {date}
  </StyledDayNumber>
);

DayNumber.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string
};

export default DayNumber;
